import { createContext } from 'react';
import type { SchedulesApiClient } from './types';

export const SchedulesApiContext = createContext<SchedulesApiClient | null>(null);
